import { styled } from '@smooth-ui/core-sc';

const BgSecondary = styled.section`
  align-items: center;
  background-color: #20335d;
  color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0;
  width: 100%;

  a {
    color: #fff;
    font-weight: normal;
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
  }
`;

export default BgSecondary;
